const filterDetails = {
  blur: {
    unit: 'px',
    default: '0',
    min: '0',
    max: '10',
  },
  brightness: {
    unit: '%',
    default: '100',
    min: '0',
    max: '200',
  },
  contrast: {
    unit: '%',
    default: '100',
    min: '0',
    max: '200',
  },
  grayscale: {
    unit: '%',
    default: '0',
    min: '0',
    max: '100',
  },
  hueRotate: {
    unit: 'deg',
    default: '0',
    min: '0',
    max: '360',
  },
  invert: {
    unit: '%',
    default: '0',
    min: '0',
    max: '100',
  },
  opacity: {
    unit: '%',
    default: '100',
    min: '0',
    max: '100',
  },
  saturate: {
    unit: '%',
    default: '100',
    min: '0',
    max: '200',
  },
  sepia: {
    unit: '%',
    default: '0',
    min: '0',
    max: '100',
  },
  blend: { unit: '', default: 'normal' },
};

export default filterDetails;



// WEBPACK FOOTER //
// ./src/filterDetails.js